import axios from 'axios';

import { useServicerStore } from '../store';

const UserService = {
  async inviteUser({ formValues, lenderId }) {
    const response = await axios.post('/user', {
      ...formValues,
      servicer_id: useServicerStore.getState()?.servicerId,
      is_super: false,
      role: 'user',
      access: [
        {
          object_type: 'lender',
          object_id: lenderId,
        },
      ],
    });

    return response.data;
  },

  async revokeUser({ userId, lenderId }) {
    const response = await axios.patch(`/user/${userId}/revoke`, {
      servicer_id: useServicerStore.getState()?.servicerId,
      object_type: 'lender',
      object_id: lenderId,
    });

    return response.data;
  },

  async updateMe(formValues) {
    const response = await axios.put('/user', formValues);

    return response.data;
  },
};

export default UserService;
